export default __webpack_public_path__ + "static/media/Gilroy-Heavy.41ca3e2d.ttf";